import * as React from 'react'
import { useTranslation } from 'react-i18next';
import {
    ChoiceGroup,
    DefaultButton,
    IChoiceGroupOption,
    Modal,
    PrimaryButton,
} from '@fluentui/react';
import * as Api from "../../../api/src"
import ModalHeader from '../../../control/modalHeader';
import { ToastAppType } from '../../../common/constant/enum/toastAppType';
import { ToastAppMsgContext } from '../../../context/toastApp.Context';
export interface ModalUnApproveTestProps {
    IsOpen: boolean,
    onCloseModal: () => void;
    onSaveClick?: () => void;
    Item?: Api.Test | null
}
const TestsApi = new Api.TestsApi();
const ModalUnApproveTest = ({ Item, IsOpen, onCloseModal, onSaveClick }: ModalUnApproveTestProps) => {
    const { t } = useTranslation();
    const [isShow, SetIsShow] = React.useState(false)
    const [SelectedKey, SetSelectedKey] = React.useState("A")
    const { setToastData } = React.useContext(ToastAppMsgContext)
    React.useEffect(() => {
        SetIsShow(IsOpen);
        SetSelectedKey("A")
    }, [IsOpen]);
    const getTitle = (): string => {
        return t("UnapproveTest");
    }
    const onClose = () => {
        onCloseModal()
        SetIsShow(false)
    }
    const onSave = async () => {
        var data = await TestsApi.apiTestsIdSetApprovedPatch(Item?.Id || 0, false, SelectedKey == 'A' ? false : true);
        if (!data || data.status != 200) return;
        setToastData({ Message: t("Successed"), Type: ToastAppType.Success });
        onCloseModal();
        SetIsShow(false);
        if (onSaveClick) {
            onSaveClick();
        }
    }
    const options: IChoiceGroupOption[] = [
        { key: 'A', text: t("DoNotUnApproveRelatedModules") },
        { key: 'B', text: t("UnApproveAllRelatedModules") },
    ];

    return (
        <Modal
            isOpen={isShow}
            isModeless={true}
        >
            <ModalHeader title={getTitle()} onCloseModal={() => {
                onClose();
            }} />
            <div className={'modal-content'} style={{ width: 500 }}>
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="ms-md12 margin-0 padding-left-0 ms-Grid-col">
                            <ChoiceGroup defaultSelectedKey={SelectedKey} options={options} onChange={(e, o) => {
                                SetSelectedKey(o?.key || '')
                            }} label={t('ThisTestIsInUsedPleaseSelectOptionBeforeUnapprove')} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={'modal-footer'}>
                <DefaultButton className={"margin-left-10"} onClick={() => { onClose(); }} >{t("Close")}</DefaultButton>
                <PrimaryButton className={"margin-left-10"} onClick={() => { onSave(); }}>{t("UnapproveTest")}</PrimaryButton>
            </div>
        </Modal>
    );
}
export default ModalUnApproveTest;


